
export default function historyNumbers () {

	const swipers = document.querySelectorAll('section.history-numbers .swiper:not(.swiper-initialized)');

	if (! swipers.length) return;



	// Init swiper
	swipers.forEach(function (container) {

		const section = container.closest('section');

		new Swiper (container, {
			loop: false,
			spaceBetween: 57,
			breakpoints: {
				0:    { slidesPerView: 1 },
				600:  { slidesPerView: 2 },
				1024: { slidesPerView: 3 },
				1360: { slidesPerView: 4 },
			},
			pagination: {
				el: section.querySelector('.swiper-pagination'),
				type: 'progressbar',
			},
			navigation: {
				prevEl: section.querySelector('.swipe-prev'),
				nextEl: section.querySelector('.swipe-next'),
			},
		});

	});



	// Counter

	const duration = 2000; // 2 seconds
	let hasAnimated = false;

	function isFullyVisible(el) {
		const rect = el.getBoundingClientRect();
		return rect.top >= 0 && rect.bottom <= window.innerHeight;
	}

	function anyNumberFullyVisible() {
		return Array.from(document.querySelectorAll('.number')).some(isFullyVisible);
	}

	function animateAllNumbers() {
		if (hasAnimated) return;

		const elements = document.querySelectorAll('.number');
		const startValues = [];
		const endValues = [];

		elements.forEach(el => {
			startValues.push(1);
			endValues.push(parseInt(el.dataset.number, 10));
			el.textContent = 1;
		});

		hasAnimated = true;
		let startTime = null;

		function step(timestamp) {
			if (!startTime) startTime = timestamp;
			const progress = Math.min((timestamp - startTime) / duration, 1);

			elements.forEach((el, index) => {
				const start = startValues[index];
				const end = endValues[index];
				const value = Math.floor(progress * (end - start) + start);
				el.textContent = value;
			});

			if (progress < 1) {
				requestAnimationFrame(step);
			} else {
				elements.forEach((el, index) => {
					el.textContent = endValues[index];
				});
			}
		}

		requestAnimationFrame(step);
	}

	function checkAndAnimate() {
		if (!hasAnimated && anyNumberFullyVisible()) {
			animateAllNumbers();
		}
	}

	function init() {
		checkAndAnimate();
		setTimeout(checkAndAnimate, 50);
		setTimeout(checkAndAnimate, 200);
	}

	let ticking = false;
	function requestTick() {
		if (!ticking) {
			requestAnimationFrame(() => {
				checkAndAnimate();
				ticking = false;
			});
			ticking = true;
		}
	}

	window.addEventListener('scroll', requestTick);
	window.addEventListener('resize', checkAndAnimate);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too. ACF's block-preview JS runs in the outer
	admin window, while this script runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=history-numbers', historyNumbers);
}
